<template>
  <div>
    <div class="shipping-address-select form-field-container" v-if="isLoggedIn && addresses.length > 0">
      <label>{{ $t('Select your address') }}</label>
      <checkout-address-select
        name="billing-address-id"
        @change="(a) => this.selectedAddress = a"
        :addresses="addresses"
        :default-address="selectedAddress"
      ></checkout-address-select>
    </div>
    <checkout-address-form
      type="billing"
      :postcode-validation-enabled="true"
      :is-logged-in="isLoggedIn"
      :is-business-account="isBusinessAccount"
      v-if="showForm"
    ></checkout-address-form>
  </div>
</template>

<script lang="ts">
  import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';

  @Component({
    name: 'checkout-address-billing',
    components: {
      'checkout-address-form': ServiceContainer().getComponent('checkout-address-form'),
      'checkout-address-select': ServiceContainer().getComponent('checkout-address-select'),
    }
  })

  export default class extends Vue {
    @Prop({ required: false, default: false }) private isLoggedIn: boolean;
    @Prop({ required: false, default: false }) private isBusinessAccount: boolean;
    @Prop({ required: false, default: [] }) private addresses: Array<object>;

    private selectedAddress: object = {};

    @Watch('selectedAddress')
    handler(nv, ov): void {
      if (nv === ov) {
        return;
      }

      this.$store.dispatch('CheckoutAddress/setBillingAddress', {
        address: nv
      });
    }

    private get billingAddress(): object {
      return this.$store.getters['CheckoutAddress/billingAddress'];
    }

    private get defaultBillingAddress(): object | null {
      return this.addresses.find((address) => address['default_billing']) ?? null;
    }

    private get showForm(): boolean {
      return !this.isLoggedIn || this.addresses.length < 1 || (this.selectedAddress['newAddress'] || false);
    }

    created(): void {
      if (Object.keys(this.billingAddress).length && window.location.hash !== '#login') {
        this.selectedAddress = this.billingAddress
      } else if (null !== this.defaultBillingAddress) {
        this.selectedAddress = this.defaultBillingAddress;
      } else if (this.addresses.length) {
        this.selectedAddress = this.addresses[0];
      }
    }
  }
</script>
